import React, { Component } from 'react';
import Button from '../button/Button';
import Toast from '../toast/Toast';
import { getCookie } from '../../js/utils';
import './login.scss';
import $http from '../../service/ajax';

export default class Login extends Component {
    state = {
      // username: 'liaozw',
      // password: 'Liaozw123456'
      username: '',
      password: ''
    }

    submit = () => {
      // window.location.href = 'check.html';
      // return;
      const {
        username,
        password
      } = this.state;

      const { type } = this.props;
      $http.post(
        '/NBGeoManager/account/login.do',
        {
          ver: '1.0',
          data: {
            username,
            password
          }
        }
      ).then((res) => {
        // console.log(getCookie('UID'));
        // const url = window.location.href
        window.location.href = `${type}.html?UID=${getCookie('UID')}`;
        // window.location.href = `repair-serial.html?UID=${getCookie('UID')}`;
      });
    }

    render() {
      const {
        username,
        password
      } = this.state;
      return (
        <div className="login-wrap">
          <div className="item">
            <input type="text" value={username} onChange={(e) => { this.setState({ username: e.target.value }); }} />
          </div>
          <div className="item">
            <input type="text" value={password} onChange={(e) => { this.setState({ password: e.target.value }); }} />
          </div>
          <Button type="ghost" className="mode-btn" onClick={this.submit}>登录</Button>
        </div>
      );
    }
}
